

































































































import {Component, Inject, Vue} from 'vue-property-decorator';
import axios from 'axios';
import FlexGridModel from '@/models/FlexGridModel';
import FlexGridEditTypeEnum from '@/enums/FlexGridEditTypeEnum';
import FlexGridDisplaySettingsEditDialog from '@/components/base/flex-grid/header/FlexGridDisplaySettingsEditDialog.vue';
import CDeleteDialog from '@/components/base/dialog/CDeleteDialog.vue';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';

/**
 * @requires ./FlexGridDisplaySettingsEditDialog.vue
 */
@Component({
    components: {CSimpleTable, CDeleteDialog, FlexGridDisplaySettingsEditDialog},
})
export default class FlexGridDisplaySettings extends Vue {
    @Inject() urlPath!: string;
    @Inject() urlQuery!: Object;
    @Inject() isIdGridConfigItemFromSettings!: boolean;
    @Inject() moduleName!: string;

    get mainData(): FlexGridModel | null {
        return this.$store.state[this.moduleName].data;
    }

    get items() {
        return this.mainData?.Config.Configs;
    }

    onAdd() {
        this.openEditDialog(FlexGridEditTypeEnum.Add);
    }
    onEdit(id: number | string) {
        this.openEditDialog(FlexGridEditTypeEnum.Edit, {idGridConfigItem: id});
    }
    onCopy(id: number | string) {
        this.openEditDialog(FlexGridEditTypeEnum.Copy, {idGridConfigItem: id});
    }
    onDelete(id: number | string) {
        (this.$refs.deleteDialog as any).open(id, {
            deleteCallback: async (id: number) => {
                try {
                    const {data: configs} = await this.$http.post(`${this.urlPath}/DeleteConfig`, null, {
                        params: {
                            idGridConfigItem: id,
                            ...this.urlQuery,
                        },
                    });
                    if (configs.Dependencies) (this.$refs.deleteDialog as any).update(configs.Dependencies);
                    else {
                        this.$emit('update:configs', configs);
                        (this.$refs.deleteDialog as any).close();
                    }
                } catch (err) {
                    console.error(err);
                }
            },
        });
    }
    async onPick(id: number | string) {
        if (this.isIdGridConfigItemFromSettings) this.$emit('idGridConfigItem:update', id);
        else
            await this.$http.post(`${this.urlPath}/SetCurrentConfig`, null, {
                params: {
                    idGridConfigItem: id,
                    ...this.urlQuery,
                },
            });
        this.$emit('refresh');
    }
    onCreateImport(id: number | string) {
        this.$parent.$emit('create:import-config', id);
    }
    async onSave(payload: any) {
        try {
            const {data: configs} = await this.$http.post(`${this.urlPath}/SaveConfig`, payload, {
                params: {
                    ...this.urlQuery,
                },
            });
            this.$emit('update:configs', configs);
            if (payload.Id === this.mainData?.Config.IdCurrentConfigItem) this.$emit('refresh');
        } finally {
            (this.$refs.editDialog as any).close();
        }
    }

    openEditDialog(editType: FlexGridEditTypeEnum, params: any = {}) {
        let type, title, urlPart;
        switch (editType) {
            case FlexGridEditTypeEnum.Add:
                type = 'add';
                title = this.$t('Common.Add');
                urlPart = '/GetConfigCreate';
                break;
            case FlexGridEditTypeEnum.Edit:
                type = 'edit';
                title = this.$t('Common.Edit');
                urlPart = '/GetConfigEdit';
                break;
            case FlexGridEditTypeEnum.Copy:
                type = 'copy';
                title = this.$t('Common.Copy');
                urlPart = '/GetConfigCopy';
                break;
            default:
                console.warn('something was wrong in getEditData');
        }
        const options = {
            url: this.urlPath,
            query: this.urlQuery,
            type,
            title,
            saveCallback: async (data: any) => {
                await this.onSave(data);
                if (
                    editType === FlexGridEditTypeEnum.Edit &&
                    this.mainData?.Config.IdCurrentConfigItem === params.idGridConfigItem
                )
                    this.$emit('reload');
            },
        };
        const CancelToken = axios.CancelToken,
            source = CancelToken.source();
        const request = this.$http.get(`${options.url}${urlPart}`, {
            params: {
                ...params,
                ...options.query,
            },
            cancelToken: source.token,
        });
        // this.$nextTick().then(() => {
        //     (this.$refs.editDialog as any).openAsync(request, source, options);
        // });
        (this.$refs.editDialog as any).openAsync(request, source, options);
    }
}
